module.exports = __webpack_public_path__ + "img/sample-4.afe9d88.webp";